import script from "./inline-alert.vue?vue&type=script&setup=true&lang=js"
export * from "./inline-alert.vue?vue&type=script&setup=true&lang=js"

import "./inline-alert.vue?vue&type=style&index=0&id=ecad89c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecad89c6"]])

export default __exports__